import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import {
    getEventsCatalogAsync,
    getSystemFieldsAsync,
    getTrackerEventsAsync,
} from "../../../../redux/slices/trackerEvents/trackerEvents.asyncActions";
import TrackerEventsList from "./TrackerEventsList.layout";
import {
    TrackerEventsListDispatchProps,
    TrackerEventsListStateProps,
} from "./TrackerEventsList.types";

const mapStateToProps = (state: any): TrackerEventsListStateProps => ({
    language: state.languagesState.languages,
    trackerEvents: state.trackerEvents.trackerEvents,
    isLoadingTrackerEvents: state.trackerEvents.isLoadingTrackerEvents,
    systemFields: state.trackerEvents.systemFields,
    filtersCatalog: state.trackerEvents.filtersCatalog,
});

const mapDispatchToProps = (dispatch: any): TrackerEventsListDispatchProps => ({
    dispatchGetTrackerEvents: () => dispatch(getTrackerEventsAsync()),
    dispatchGetEventsCatalog: () => dispatch(getEventsCatalogAsync()),
    dispatchGetSystemFields: () => dispatch(getSystemFieldsAsync()),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(TrackerEventsList);
